/* W&V sticky add-to-cart */
(function () {
  var bar = document.getElementById('wv-satc');
  var json = document.getElementById('wv-satc-data');
  if (!bar || !json) return;

  var data = JSON.parse(json.textContent);
  var $ = function (sel) { return bar.querySelector(sel); };
  var selects = [].slice.call(bar.querySelectorAll('.wv-satc__select'));
  var qty = $('.wv-satc__qty input');
  var button = $('.wv-satc__button');
  var variant = find(function (v) { return v.id === data.current; });

  function find(test) {
    for (var i = 0; i < data.variants.length; i++) if (test(data.variants[i])) return data.variants[i];
    return null;
  }

  function render() {
    var ok = !!(variant && variant.available);
    button.disabled = !ok;
    button.textContent = ok ? data.addText : data.soldOutText;
    if (!variant) return;
    selects.forEach(function (s, i) { s.value = variant.options[i]; });
    $('.wv-satc__current').textContent = variant.price;
    $('.wv-satc__compare').textContent = variant.compare || '';
    $('.wv-satc__compare').hidden = !variant.compare;
    if (variant.image && $('.wv-satc__image')) $('.wv-satc__image').src = variant.image;
  }

  /* Kleur/maat kiezen */
  selects.forEach(function (select) {
    select.addEventListener('change', function () {
      var values = selects.map(function (s) { return s.value; });
      var match = find(function (v) { return v.options.join('|') === values.join('|'); });
      if (match) { variant = match; render(); } else { button.disabled = true; button.textContent = data.soldOutText; }
    });
  });

  /* Aantal (alleen tablet/computer) */
  bar.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (step) qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + +step.dataset.step));
  });

  /* Grote knop van de pagina: balk tonen zodra die boven uit beeld is, en variant bovenaan volgen */
  var main = [].slice.call(document.querySelectorAll('buy-buttons')).filter(function (el) {
    return !el.closest('product-quick-add, quick-buy-drawer');
  })[0];
  var form = main && document.getElementById(main.getAttribute('form'));
  if (form) form.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant && find(function (x) { return x.id === e.detail.variant.id; });
    if (v) { variant = v; render(); }
  });

  function toggle() {
    var show = main ? main.getBoundingClientRect().bottom < 0 : scrollY > 400;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
  }
  addEventListener('scroll', toggle, { passive: true });
  addEventListener('resize', toggle);

  /* Toevoegen: alleen naar de cart drawer (wv-cart-drawer.js ververst en opent hem) */
  button.addEventListener('click', function () {
    if (!variant || button.disabled) return;
    var quantity = qty && qty.offsetParent ? parseInt(qty.value, 10) || 1 : 1;
    button.classList.add('is-loading');
    fetch(Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: quantity }] })
    })
      .then(function (r) { return r.ok ? null : r.json(); })
      .then(function (err) {
        if (err) { button.textContent = err.description || data.soldOutText; setTimeout(render, 2500); }
        else if (qty) qty.value = 1;
      })
      .catch(function () {})
      .then(function () { button.classList.remove('is-loading'); });
  });

  bar.hidden = false;
  render();
  toggle();
})();